export default "__VITE_ASSET__DU1hAjD9__"